// extracted by mini-css-extract-plugin
export var discountSelect = "discount-module--discountSelect--b2ca0";